import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Audio extends Model {
  resource () {
    return 'audios'
  }

  get uploadedDate () {
    return dayjs.utc(this.created_at).format('MMM DD, YYYY hh:mm A')
  }
}
